import { useEffect } from "react";
import * as C from "./styles.js";
import { Link } from "react-router-dom";
import { useState } from "react";
import { ErrorMessage } from "../styles.js";
import { removeEpisodeFromWatching } from "../save-on-watching/index.js";

export default function Episodes({
  movie,
  movie_id,
  movie_id_imdb,
  movie_season,
  episodes,
  episodes_watching,
  handleSeasonChange,
  setWatchData,
  setWatchDataWatching,
  seasons,
  defineAsWatched,
  setEpisodesWatching,
  episodesRef,
  episodeRefs,
}) {
  const [layoutStyle, setLayoutStyle] = useState("list");
  const [episodesLengthVisible, setEpisodesLengthVisible] = useState(20);

  useEffect(() => {
    setEpisodesLengthVisible(20);
  }, [episodes]);

  const handleEpisodeClick = (e, episode, episodeWatching) => {
    console.log("Clicou no episódio:", episode?.src);
    if (episode?.src?.startsWith("https://lightspeedst.net/")) {
      e.preventDefault();
      window.open(episode?.src, "_self");
      return;
    }

    defineWatch(episode, episodeWatching);
  };
  const converter = (minutos) => {
    const horas = Math.floor(minutos / 60);
    const min = minutos % 60;
    const textoHoras = `${horas}`;
    const textoMinutos = `${min}`;

    if (minutos <= 59) {
      return `${textoMinutos}min`;
    } else if (minutos == 60) {
      return `${textoHoras}h`;
    } else if (minutos >= 61) {
      return `${textoHoras}h, ${textoMinutos}min`;
    }
  };

  const loadMore = () => {
    const remainingEpisodes = episodes?.length - episodesLengthVisible;
    const nextBatch = Math.min(remainingEpisodes, 10);
    setEpisodesLengthVisible(
      (prevCastLengthVisible) => prevCastLengthVisible + nextBatch,
    );
  };

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 600px)");

    const handleMediaChange = (e) => {
      if (e.matches) {
        setLayoutStyle("list");
      }
    };

    // Adiciona o listener de mudanças na mídia
    mediaQuery.addEventListener("change", handleMediaChange);

    // Verifica o estado inicial da tela
    if (mediaQuery.matches) {
      handleMediaChange(mediaQuery);
    }

    // Remove o listener quando o componente é desmontado
    return () => mediaQuery.removeEventListener("change", handleMediaChange);
  }, []);

  // calcula a porcentagem assistida, os valores devem estar em segundos
  function porcents(total, watched) {
    if (total === 0) return 0; // Evita divisão por zero
    return (watched / total) * 100;
  }

  const defineWatch = (episode, episodeWatching) => {
    setWatchData(episode);
    setWatchDataWatching(episodeWatching);
  };

  return (
    <C.Container layoutStyle={layoutStyle} ref={episodesRef}>
      <header>
        <h2 className="title-episodes-desktop">Episódios</h2>
        <div className="container-select-season">
          <div className="div-select-season">
            <h2 className="title-episodes-mobile">Episódios</h2>
            <button
              className={layoutStyle === "list" ? "active" : ""}
              onClick={() => setLayoutStyle("list")}
            >
              <i className="fas fa-bars"></i>
            </button>
            <button
              className={layoutStyle === "grid" ? "active" : ""}
              onClick={() => setLayoutStyle("grid")}
            >
              <i className="fas fa-grip"></i>
            </button>
          </div>
          {seasons?.length > 0 && ( // Verifique se seasons possui dados
            <C.SeasonSelectorContainer>
              {seasons && seasons.length > 0 && (
                <C.SeasonSelect
                  id="season-select"
                  value={movie_season}
                  onChange={(e) => {
                    handleSeasonChange(e.target.value);
                  }}
                >
                  {seasons.map((season, key) => (
                    <option key={key} value={season.season_number}>
                      {season?.season_number == 0
                        ? "Especiais"
                        : season.name || `Temporada ${season.season_number}`}
                    </option>
                  ))}
                </C.SeasonSelect>
              )}
            </C.SeasonSelectorContainer>
          )}
        </div>
      </header>
      <header>
        <div className="div-watched-example">
          <div>
            <button
              disabled
              className="button-change-watched-example button-watched-example"
            >
              <i className="fas fa-eye"></i>
            </button>
            <span>Marcado como assistido</span>
          </div>
          <div>
            <button disabled className="button-change-watched-example">
              <i className="fas fa-eye"></i>
            </button>
            <span>Não assistido</span>
          </div>
        </div>
      </header>
      <div className="container-episodes">
        {episodes?.slice(0, episodesLengthVisible).map((episode, key) => {
          const episodeWatching = Array.isArray(episodes_watching)
            ? episodes_watching?.find(
                (ep) => ep?.episode_id == episode?.episode_id,
              )
            : null;

          return (
            <div className="container-episode" key={key}>
              <Link
                ref={(el) => (episodeRefs.current[episode?.episode_id] = el)}
                className="episode"
                to={`?watch=true&season=${movie_season}&episode=${episode?.episode_details?.episode_number}`}
                onClick={(e) => handleEpisodeClick(e, episode, episodeWatching)}
              >
                <div className="container-image">
                  <img
                    src={
                      episode?.episode_details?.still_path
                        ? `https://image.tmdb.org/t/p/w400${episode?.episode_details?.still_path}`
                        : `https://image.tmdb.org/t/p/w400${movie?.backdrop_path}`
                    }
                    alt={`imagem do episódio ${episode?.episode_details?.episode_number} da temporada ${episode?.episode_details?.season_number} da série ${movie?.name}`}
                  />
                  {episodeWatching?.episode_id ? (
                    <section className="section-info-watching">
                      <section>
                        <div className="div-porcentos-assistidos">
                          <div
                            style={{
                              width: `${porcents(episodeWatching?.episode_duration, episodeWatching?.episode_seconds_watched)}%`,
                            }}
                          ></div>
                        </div>
                      </section>
                    </section>
                  ) : null}
                </div>
                <div className="details">
                  <section>
                    <h2 title={episode?.episode_details?.name} className="name">
                      {episode?.episode_details?.episode_number}.{" "}
                      {episode?.episode_details?.name}
                    </h2>
                    {episode?.episode_details?.runtime > 0 && (
                      <span>
                        <i className="fas fa-clock"></i>{" "}
                        {converter(episode?.episode_details?.runtime)}
                      </span>
                    )}
                  </section>
                  <p className="overview">
                    {episode?.episode_details?.overview ||
                      "Não há uma descrição para este episódio"}
                  </p>
                </div>
              </Link>
              {episode?.episode_details?.runtime &&
                (() => {
                  const watched =
                    episodeWatching?.episode_seconds_watched / 60 ===
                    episode?.episode_details?.runtime;

                  return (
                    <button
                      className={`button-change-watched ${watched ? "button-watched" : null}`}
                      onClick={() =>
                        !watched
                          ? defineAsWatched(
                              episode,
                              episode?.episode_details?.runtime * 60,
                            )
                          : removeEpisodeFromWatching(
                              episode,
                              episodes_watching,
                              setEpisodesWatching,
                              movie_id_imdb,
                            )
                      }
                    >
                      <i className="fas fa-eye"></i>
                    </button>
                  );
                })()}
            </div>
          );
        })}
      </div>
      {episodes?.length === 0 && (
        <ErrorMessage margin={"20px 0 0 0"}>
          <p>
            <i className="fas fa-triangle-exclamation"></i> Nenhum episódio
            disponível. Por favor, troque de temporada!
          </p>
          <small>(Temporada {movie_season})</small>
        </ErrorMessage>
      )}
      {episodes?.length > episodesLengthVisible && (
        <section className="section-more-movies">
          <button onClick={loadMore}>
            <i className="fas fa-plus"></i>
          </button>
        </section>
      )}
    </C.Container>
  );
}
